




















import {
  Vue,
  Component,
  Mixins,
  Prop,
  Model,
  Watch
} from "vue-property-decorator";
import MyCommon from "@/mixins/common";

@Component
export default class extends Mixins(MyCommon) {
  previewVisible = false;

  previewImage = "";

  fileList: any[] = [];

  @Model() value!: any[];

  //   @Watch('value')
  //   watchValue(val: any, oldVal: any) {
  //     console.log(val)
  //     console.log(oldVal)
  //   }

  mounted() {
    // console.log(this.value)
    this.fileList = this.value;
  }

  handleCancel1() {
    this.previewVisible = false;
  }

  handlePreview(file: any) {
    this.previewImage = file.url || file.thumbUrl;
    this.previewVisible = true;
  }

  handleRemove(file: any) {
    return new Promise((resolve, reject) => {
      this.$confirm({
        title: "确认信息",
        content: "确定要删除图片？",
        onOk: () => {
          const fileList = this.value;
          this.value.splice(fileList.indexOf(file), 1);
          resolve(true);
        },
        onCancel: () => {
          reject(false);
        }
      });
    });
  }

  handleChange({ file, fileList, event }: any) {
    // if (file.status === 'removed') {
    //   this.fileList = fileList
    //   // this.value = fileList
    //   console.log(file)
    //   console.log(event)
    //   console.log(fileList)
    //   this.value = fileList
    //   console.log(this.value)
    //   // this.$emit("change", this.value);
    // }
  }

  beforeUpload(file: any) {
    const isJPG = file.type === "image/jpeg" || file.type === "image/jpg";
    const isPNG = file.type === "image/png";
    const isGIF = file.type === "image/gif";

    if (!isJPG && !isPNG && !isGIF) {
      this.$message.error("只支持jpg、png和gif的图片!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      this.$message.error("图片不能超过2MB!");
    }
    return (isJPG || isPNG || isGIF) && isLt2M;
  }

  customRequest(file: any) {
    // console.log(file)
    const check = this.fileList.length < 10;
    if (!check) {
      this.$message.warning("最多只能上传10张");
    }
    // console.log(file);
    const params = new FormData();
    params.append("chunk", "0");
    params.append("chunks", "1");
    params.append("file", file.file, file.file.name);
    this.$store.dispatch("stadium/uploadFile", params).then((res: any) => {
      if (res && res.Data) {
        this.setValue(file.file, res.Data);
      }
    });
    // this.setValue("/2019/06/3/1559533033.jpg");

    // return check;
    return false;
  }

  setValue(file: any, val: string) {
    // console.log(this.value)
    this.value.push({
      uid: file.uid,
      name: val,
      url: this.commonUrl(val),
      status: "done"
    });
    // console.log(this.value)
    this.fileList = this.value;
    this.$emit("change", this.value);
  }
}
